var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('span',[_c('a',[_c('div',[_c('i',{staticClass:"iconfont icon-shuaxin"})]),_c('p',[_vm._v("READ MORE")])])])])}]

export { render, staticRenderFns }